import React from 'react';
import { bool, func, string } from 'prop-types';
import ModalWithCloseButton from 'components/wdx/ModalWithCloseButton';
import AddAddress from 'components/Address/AddAddress';
import EditAddress from 'components/Address/EditAddress';

import styles from './AddressFormModal.scss';

const addressFormModalDefaultPropOnAfterSubmit = () => {};

const AddressFormModal = ({
  addAddressTitle = 'Add Address',
  editAddressTitle = 'Edit Address',
  isEdit = false,
  onAfterSubmit = addressFormModalDefaultPropOnAfterSubmit,
  ...props
}) => {
  const { onCloseModal } = props;
  const closeModal = address => {
    onCloseModal(isEdit, false);
    onAfterSubmit(address);
  };
  return (
    <ModalWithCloseButton
      fullScreenTransitions
      {...{
        ...props,
        addAddressTitle,
        editAddressTitle,
        isEdit,
        onAfterSubmit,
        closeModal: () => onCloseModal(isEdit, true),
      }}
    >
      <section className={styles['address-form']} tabIndex="-1">
        {isEdit ? (
          <EditAddress
            {...{ addAddressTitle, editAddressTitle, isEdit, ...props }}
            onAfterSubmit={closeModal}
            pageTitle={editAddressTitle}
          />
        ) : (
          <AddAddress
            {...{ addAddressTitle, editAddressTitle, isEdit, ...props }}
            onAfterSubmit={closeModal}
            pageTitle={addAddressTitle}
          />
        )}
      </section>
    </ModalWithCloseButton>
  );
};

AddressFormModal.propTypes = {
  addAddressTitle: string,
  editAddressTitle: string,
  isEdit: bool,
  onCloseModal: func.isRequired,
  onAfterSubmit: func,
};

export default AddressFormModal;
